<div
    class="certificate-root"
    fxLayout="row"
    fxLayoutAlign="start center"
    (click)="isDownloadIconVisible ? onClickButton($event) : $event.stopPropagation()"
    (mouseenter)="isHovered = true"
    (mouseleave)="isHovered = false"
>
    <span fxLayout="row" fxLayoutAlign="start center" class="certificate-pill pr-16 rounded-full pointer" [ngClass]="isHovered ? bgHoverColor : bgColor">
        <span fxLayoutAlign="center center" class="oval rounded-full min-w-9 min-h-9 shrink-0">
            <mat-icon svgIcon="certificate"></mat-icon>
        </span>

        <div class="certificate-content" fxLayout="row" fxLayoutAlign="start center">
            <span class="certificate-label text-gray-700 text-base sm:text-sm mx-8" tabindex="0" [tooltipIfTruncated]="label">
                {{ label }}
            </span>
            <mat-icon class="shrink-0" svgIcon="download" *ngIf="isDownloadIconVisible"></mat-icon>
        </div>
    </span>
</div>
